import controller from './template-detail.controller';
import templateBase from './templates/template-detail-base.view.html';

let TemplateDetailComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  return templateBase;

}


export default TemplateDetailComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/templates/template-detail/template-detail.component.js
 **/